module.exports = __webpack_public_path__ + "static/media/single-user.61f9164c.svg";